@if (
  VendorForm &&
  (VendorForm.controls['CompanyVendors']?.value)!.length > 0 &&
  CompanyVendors.length > 0
) {
  <div class="cvo-selection">
    @for (
      companyVendorForm of $any(VendorForm.controls['CompanyVendors']).controls;
      track companyVendorForm
    ) {
      @if (hasOffices(companyVendorForm)) {
        <div class="cvo-client">
          <div class="cvo-client__company">
            <span class="cvo-client__name">
              {{ getClientName(companyVendorForm) }}
            </span>
            <span class="cvo-client__count">
              {{
                companyVendorForm.controls['CompanyVendorOffices'].controls
                  .length
              }}
              of {{ getClientOfficeCount(companyVendorForm) }}
              {{
                getClientOfficeCount(companyVendorForm) === 1
                  ? 'office'
                  : 'offices'
              }}
            </span>
          </div>

          @if (
            companyVendorForm.controls['CompanyVendorOffices'].controls
              .length === 0
          ) {
            <p class="cvo-client__empty">No offices selected</p>
          } @else {
            <div class="cvo-client__tags">
              @for (
                CompanyVendorOffice of companyVendorForm.controls[
                  'CompanyVendorOffices'
                ].controls;
                track CompanyVendorOffice;
                let index = $index
              ) {
                <span class="cvo-tag">
                  {{
                    CompanyVendorOffice.controls['CompanyOffice'].controls[
                      'officeName'
                    ].value
                  }}
                  <button
                    type="button"
                    class="cvo-tag__remove"
                    [title]="
                      'Remove ' +
                      CompanyVendorOffice.controls['CompanyOffice'].controls[
                        'officeName'
                      ].value
                    "
                    [attr.aria-label]="
                      'Remove ' +
                      CompanyVendorOffice.controls['CompanyOffice'].controls[
                        'officeName'
                      ].value
                    "
                    (click)="
                      deselectCompanyVendorOffice(companyVendorForm, index)
                    "
                  >
                    <i class="bi bi-x-lg"></i>
                  </button>
                </span>
              }
            </div>
          }

          <button
            type="button"
            class="btn btn-ghost btn-sm cvo-client__action"
            [attr.aria-label]="
              (companyVendorForm.controls['CompanyVendorOffices'].controls
                .length === 0
                ? 'Select offices for '
                : 'Edit offices for ') + getClientName(companyVendorForm)
            "
            (click)="chooseCompanyVendorOffices(companyVendorForm)"
          >
            @if (
              companyVendorForm.controls['CompanyVendorOffices'].controls
                .length === 0
            ) {
              <i class="bi bi-plus-lg me-1"></i>
              Select offices
            } @else {
              <i class="bi bi-pencil me-1"></i>
              Edit offices
            }
          </button>
        </div>
      }
    }
  </div>
}
